<template>
  <div>
    <!-- empty div required for root dialog component -->
    <b-modal
      ref="modal"
      :title="$t('affiliates.add_new')"
      :ok-disabled="!model.user_id"
      size="sm"
      centered
    >
      <form ref="form" @submit="save">
        <fields
          :fields="fields.all()"
          :model="model"
          :errors="errors"
          layout="vertical"
        />
      </form>
    </b-modal>
  </div>
</template>

<script>
import filter from 'lodash-es/filter'
import { FormMixin } from 'stylemix-base'
import UsersApi from '../users/UsersApi'

export default {
  name: 'AddAffiliate',

  mixins: [FormMixin],

  data() {
    return {
      model: {
        user_id: null,
        affiliate: true,
        affiliate_commission: null,
        auto_billing: false,
      },
    }
  },

  mounted() {
    const modal = this.$refs.modal

    modal.show()

    modal.$on('close', () => {
      this.$close()
    })

    modal.$on('ok', event => {
      event.preventDefault()
      this.save()
    })

    modal.$on('cancel', () => {
      this.$close()
    })

    const promise = new UsersApi().create().then(result => {
      const fields = filter(result.fields, field => {
        let only = ['affiliate_commission', 'auto_billing', 'deferred_payments']
        return only.indexOf(field.attribute) !== -1
      })
      fields.unshift({
        attribute: 'user_id',
        component: 'relation-field',
        label: this.$t('affiliates.user'),
        ajax: true,
        source: {
          url: 'users',
          params: {
            'where[affiliate]': false,
            context: 'options',
          },
        },
      })

      this.setFields(fields)
    })

    modal.$on('shown', () => {
      this.$uiBlocker(promise, modal.$refs.content)
    })
  },

  methods: {
    save() {
      return this.$uiBlocker(
        new UsersApi()
          .update(this.model.user_id, this.model)
          .then(result => {
            this.$refs.modal.hide()
            this.$close(result.data)
            this.$toast.success(result.message)
          })
          .catch(error => {
            if (error.status === 422) {
              this.setValidationErrors(error.data.errors)
            }
            return Promise.reject(error)
          }),
        this.$refs.modal.$refs.content,
      )
    },
  },
}
</script>
